import type { MarketId, MarketQuote } from '@omnia/shared';
import { LOCALE } from '../lib/i18n.ts';

export const MARKET_LABELS: Record<MarketId, { short: string; long: string }> = {
  usd: { short: 'USD', long: 'ABD Doları / TL' },
  eur: { short: 'EUR', long: 'Euro / TL' },
  gold: { short: 'Altın', long: 'Gram altın (TL)' },
  btc: { short: 'BTC', long: 'Bitcoin (USD)' },
  ceyrek: { short: 'Çeyrek', long: 'Çeyrek altın (TL)' },
  yarim: { short: 'Yarım', long: 'Yarım altın (TL)' },
  tam: { short: 'Tam', long: 'Tam altın (TL)' },
  cumhuriyet: { short: 'Cumhuriyet', long: 'Cumhuriyet altını (TL)' },
  ayar22: { short: '22 ayar', long: '22 ayar altın, gram (TL)' },
};

const price = new Intl.NumberFormat(LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const wholePrice = new Intl.NumberFormat(LOCALE, { maximumFractionDigits: 0 });
const change = new Intl.NumberFormat(LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2, signDisplay: 'exceptZero' });

/** 49,00 for currencies, 83.928 for Bitcoin, where cents are noise. */
export function formatMarketValue(quote: Pick<MarketQuote, 'id' | 'value'>): string {
  return quote.id === 'btc' ? wholePrice.format(quote.value) : price.format(quote.value);
}

/** `+0,32%` — the sign leads and the percent sign trails, as the bar's tickers read. */
export function formatChange(changePct: number): string {
  return `${change.format(changePct)}%`;
}

export type Direction = 'up' | 'down' | 'flat';

/** Rounded first so a change that displays as 0,00% is not drawn as a move. */
export function directionOf(changePct: number | null): Direction {
  if (changePct === null) return 'flat';
  const rounded = Math.round(changePct * 100);
  return rounded > 0 ? 'up' : rounded < 0 ? 'down' : 'flat';
}
